import { createAsyncType } from '@/store/utils/mutation-types'

export default {
  GET_LAST_QUERY: createAsyncType('GET_LAST_QUERY'),
  GET_HISTORY: createAsyncType('GET_HISTORY')
}